<template>
    <div :class="'app-activation-wrapper ' + showActivationView">
      <ActivationInfo v-if="showStep(infoStepName)"
                        :activation-code-min="activationCodeMin"
                        :activation-code-max="activationCodeMax"
                        :next-step="personalDataInputStepName"
        >
          <template v-for="slot in possibleChildSlotsFor('Info')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </ActivationInfo>
      <ActivationPersonalDataInput v-if="showStep(personalDataInputStepName)"
                                    :previous-step="infoStepName"
                                    :alowed-min-age="16"
                                    :next-step="summaryStepName"
      >
        <template v-for="slot in possibleChildSlotsFor('PersonalData')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </ActivationPersonalDataInput>
      <ActivationSummary v-if="showStep(summaryStepName)"
                          :previous-step="personalDataInputStepName"
                          :next-step="successStepName"
      >
        <template v-for="slot in possibleChildSlotsFor('Summary')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </ActivationSummary>
      <ActivationSuccess v-if="showStep(successStepName)">
        <template v-for="slot in possibleChildSlotsFor('Success')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </ActivationSuccess>
      <ActivationInfoModal :next-step="personalDataInputStepName">
        <template v-for="slot in possibleChildSlotsFor('InfoModal')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </ActivationInfoModal>
    </div>
</template>

<script>
import ActivationInfo, { stepName as infoStepName } from '@/components/process/BILD/Activation/Info/ActivationInfo.vue'
import ActivationPersonalDataInput, { stepName as personalDataInputStepName } from '@/components/process/BILD/Activation/PersonalData/PersonalDataInput.vue'
import ActivationSummary, { stepName as summaryStepName } from '@/components/process/BILD/Activation/Wrapper/ActivationSummaryWrapper.vue'
import { mapGetters, mapMutations } from 'vuex'
import ActivationSuccess, { stepName as successStepName } from '@/components/process/BILD/Activation/Success/Success.vue'
import transaction from '@/mixins/transaction'
import slotProxy from '@/mixins/slotProxy'
import extraData from '@/mixins/extraData'
import processWrapper from '@/mixins/processWrapper'
import ActivationInfoModal from '../Info/ActivationInfoModal.vue'

export default {
  name: 'BildActivationWrapper',
  import: {
    infoStepName,
    personalDataInputStepName,
    summaryStepName,
    successStepName
  },
  mixins: [
    transaction('activation'),
    slotProxy(),
    extraData(),
    processWrapper('showActivationView')
  ],
  props: {
    activationCodeMin: {
      type: Number
    },
    activationCodeMax: {
      type: Number
    }
  },
  methods: {
    ...mapMutations('activation', [
      'setBrandUrl',
      'goToStep'
    ])
  },
  computed: {
    ...mapGetters('activation', [
      'showActivationView'
    ])
  },
  components: {
    ActivationInfoModal,
    ActivationSuccess,
    ActivationPersonalDataInput,
    ActivationInfo,
    ActivationSummary
  }
}
</script>
